<div class="container mt-n5" *ngIf="provider">
    <div class="row">
        <div class="col">
            <div class="bc-card p-0">
                <div class="border-bottom p-3">
                    <div class="d-flex d-row align-items-center">
                        <span class="flex-grow-1 text-dimmed mx-4" translate>
                            ProviderPayRates.PayRatesCardTitle
                        </span>
                        <div class="" *ngIf="!isEditing; else editButtonsPanel">
                            <button class="btn bc-button mr-2" (click)="backToTrainerDetails()" translate>
                                ProviderPayRates.BackToProfileButtonLabel
                            </button>
                            <button type="button" class="btn btn-success mr-2" (click)="onEdit()"
                                [showIfPrivileges]="'GroupClasses.canManagePayRates'" [clubIds]="providerHomeClubId"
                                translate>
                                ProviderPayRates.EditButtonLabel
                            </button>
                        </div>
                    </div>
                    <ng-template #editButtonsPanel>
                        <div class="">
                            <button class="btn bc-button bt-cancel mr-2" translate (click)="onCancel()">
                                General.Cancel
                            </button>
                            <button class="btn btn-success mr-2" (click)="onSave()"
                                [showIfPrivileges]="'GroupClasses.canManagePayRates'" [clubIds]="providerHomeClubId"
                                translate>
                                ProviderPayRates.SaveButtonLabel
                            </button>
                        </div>
                    </ng-template>

                </div>
                <div class="p-4">
                    <div class="m-3">
                        <div *ngIf="!isEditing; else payRatesEdit">
                            <app-provider-current-payrates [payRates]="currentPayRates">
                            </app-provider-current-payrates>
                            <button class="btn btn-link btn-link-green btn-no-transform mt-1"
                                (click)="onAddCategorySpecificPayRate()"
                                [showIfPrivileges]="'GroupClasses.canManagePayRates'" [clubIds]="providerHomeClubId">
                                    <span class="ic-add-green"></span>
                                   <span class="add-payrate-text"> {{ 'ProviderPayRates.AddCategorySpecificPayRateLabel' | translate }}</span>
                            </button>
                        </div>
                        <ng-template #payRatesEdit>
                            <app-provider-payrates-edit [form]="payRateSetForm" [clubs]="provider.clubs" [managementContext]="(context$ | async)"></app-provider-payrates-edit>
                        </ng-template>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="bc-card">
                <app-provider-payrates-history [providerId]="provider.id"></app-provider-payrates-history>
            </div>
        </div>
    </div>

</div>